"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DecodedTempUserToken {
}
exports.DecodedTempUserToken = DecodedTempUserToken;
//# sourceMappingURL=DecodedTempUserToken.js.map